module.exports = __webpack_public_path__ + "static/media/Callbreak.7162eba2.png";